module.exports = __webpack_public_path__ + "03_medium_brown.6bf757d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_medium_brown.png
// module id = mHno
// module chunks = 0